import {
  AppNotification,
  NotificationType,
} from '../components/notification/Notification'
import {
  ErrorMsgFields,
  ErrorBaseResponseDto,
  TFormFields,
  IValidationErrorResponse,
  IFetchError,
} from '../core/api/dto/ErrorObjDto'
import { CookingStatus, IOrder } from '../core/api/dto/OrderObjDto'
import React from 'react'

export const scrollUp = (
  refRoot: React.MutableRefObject<HTMLDivElement | null>,
  heightChild: number,
  margin: number = 20,
) => {
  if (refRoot && refRoot.current && heightChild) {
    refRoot.current.scrollTop -= heightChild + margin
  }
}

export const scrollDown = (
  ref: React.MutableRefObject<HTMLDivElement | null>,
  heightChild: number,
  margin: number = 20,
) => {
  if (ref && ref.current) {
    ref.current.scrollTop += heightChild + margin
  }
}

export const scrollLeft = (
  ref: React.MutableRefObject<HTMLDivElement | null>,
) => {
  if (ref && ref.current) {
    ref.current.scrollLeft -= ref.current?.getBoundingClientRect().width
  }
}
export const scrollRight = (
  ref: React.MutableRefObject<HTMLDivElement | null>,
) => {
  if (ref && ref.current) {
    ref.current.scrollLeft += ref.current?.getBoundingClientRect().width
  }
}

export function compareProps<Props extends object>(
  prevProps: Props,
  nextProps: Props,
) {
  return JSON.stringify(prevProps) === JSON.stringify(nextProps)
}

export const filterMealItems = (info: IOrder, isWaiterPage: boolean = true) => {
  const readyDishes = info.orderLines.filter(
    (el) =>
      el.orderLineCookingStatuses?.cookingStatus === CookingStatus.Cook_done,
  )
  const atWorkDishes = info.orderLines.filter(
    (el) =>
      el.orderLineCookingStatuses?.cookingStatus === CookingStatus.Cooking,
  )
  const notReadyDishes = info.orderLines.filter(
    (el) =>
      !el.orderLineCookingStatuses ||
      el.orderLineCookingStatuses.cookingStatus === CookingStatus.Waiting,
  )

  return isWaiterPage
    ? [...readyDishes, ...atWorkDishes, ...notReadyDishes]
    : [...notReadyDishes, ...atWorkDishes]
}

function isFetchError(error: ErrorBaseResponseDto): error is IFetchError {
  return 'error' in error
}
export const errorHandling = (response: ErrorBaseResponseDto) => {
  const { data } = response

  if (!data && !isFetchError(response)) {
    return AppNotification({
      msg: 'Нет соединения!',
      type: NotificationType.error,
    })
  }

  if (typeof data === 'string') {
    return AppNotification({
      msg: data,
      type: NotificationType.error,
    })
  }

  if (
    typeof data === 'object' &&
    'errors' in data &&
    Array.isArray(data.errors)
  ) {
    const first = data.errors[0]
    return AppNotification({
      msg: first?.detail || 'Ошибка запроса',
      type: NotificationType.error,
    })
  }

  if (isFetchError(response) && response.error) {
    return AppNotification({
      msg: response.error,
      type: NotificationType.error,
    })
  }

  return AppNotification({
    msg: 'Неизвестная ошибка',
    type: NotificationType.error,
  })
}

export const filterOrders = (orders: IOrder[]) => {
  const filterOrders = [] as IOrder[]

  orders.forEach((el) => {
    if (el.orderLines.length) {
      const orderLines = el.orderLines.filter((item) => {
        return item.quantity !== 0
      })

      orderLines.length && filterOrders.push({ ...el, orderLines })
    }
  })

  return filterOrders
}
